import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";
import portalManagerApi from 'constants/portalManagerApi';

export interface GetFileTypesResponse {
  RmiUid: number,
  RmiParameter1: string,
  RmiPvalue: string,
  RmiCreatedBy: string,
  RmiCreatedDate: string,
  RmiModifiedBy: string,
  RmiModifiedDate: string
};

export const getFileTypes = (parameter: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_FILE_TYPES_REQUEST });

  return api.parameter.getFileTypes(parameter)
    .then((res: any) => {

      dispatch({
        type: types.GET_FILE_TYPES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_FILE_TYPES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getServer = (companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_SERVER_REQUEST });

  return api.parameter.getServer(companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_SERVER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_SERVER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getCompanies = () => (dispatch: ThunkDispatch<any, any, any>) => {
  dispatch({ type: types.GET_COMPANIES_REQUEST });

  return portalManagerApi.public
    .getCompanies()
    .then((res: any) => {
      dispatch({
        type: types.GET_COMPANIES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, "response.data.msg", "Get failed!");
      const errors = _get(err, "response.data.errors", {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_COMPANIES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
